import { Injectable } from "@angular/core";

@Injectable()
export class IgnoreNullsSortService {
  public sort(array: any[], field: string) {
    if (!Array.isArray(array)) {
      return;
    }

    const present = [];
    const empty = [];

    for (const item of array) {
      if (item[field] != null) {
        present.push(item);
      } else {
        empty.push(item);
      }
    }

    for (const item of empty) {
      present.push(item);
    }

    return present;
  }
}
